import { DigitInput, type DigitInputProps } from 'components/shared/digit-input';
import type { ILockBtnProps } from 'components/shared/WithLock/LockBtn';
import { LockBtn } from 'components/shared/WithLock/LockBtn';

export type DigitInputWithLockProps = DigitInputProps & ILockBtnProps;

export function DigitInputWithLock(props: DigitInputWithLockProps) {
  const { isLocked, isDisabled, isLoading, onLockChanged, tabIndex, isDelegated, ...digitProps } = props;

  return (
    <DigitInput
      {...digitProps}
      isReadOnly={isLocked || digitProps.isReadOnly}
      append={
        <LockBtn
          isDelegated={isDelegated}
          isLocked={isLocked}
          onLockChanged={onLockChanged}
          isDisabled={isDisabled}
          isLoading={isLoading}
          tabIndex={tabIndex}
          className="bg-transparent border-none"
        />
      }
    />
  );
}

DigitInputWithLock.displayName = 'DigitInputWithLock';
